<template>
  <div :class="carouselClasses" @mouseenter.stop="handleMouseEnter" @mouseleave.stop="handleMouseLeave">
    <div class="el-carousel__container" :style="{ height: height }">
      <!--左右切换-->
      <div class="nav_btn nav_btn_left">
        <div class="icon left_icon">
          <img :src="filePath + '/nemojoyWebSiteFile/imgs/indexCarousel/arrow_icon.svg'" alt="" class="arrow_icon" @mouseenter="handleButtonEnter('left')" @mouseleave="handleButtonLeave" @click.stop="throttledArrowClick(activeIndex - 1)">
        </div>
      </div>
      <div class="nav_btn nav_btn_right">
        <div class="icon">
          <img :src="filePath + '/nemojoyWebSiteFile/imgs/indexCarousel/arrow_icon.svg'" alt="" class="arrow_icon" @mouseenter="handleButtonEnter('right')" @mouseleave="handleButtonLeave" @click.stop="throttledArrowClick(activeIndex + 1)">
        </div>
      </div>
      <slot />
    </div>

    <ul v-if="indicatorPosition !== 'none'" :class="indicatorsClasses">
      <li v-for="(item, index) in items" :key="index" :class="[ 'el-carousel__indicator', 'el-carousel__indicator--' + direction, { 'is-active': index === activeIndex }]" @mouseenter="throttledIndicatorHover(index)" @click.stop="handleIndicatorClick(index)">
        <div class="el-carousel__button" :style="'background-color: transparent; background-image: url(' + filePath + '/nemojoyWebSiteFile/imgs/indexCarousel/indexCarouselbutton.png); background-repeat: no-repeat; background-size: 100% 100%;'" />
      </li>
    </ul>
  </div>
</template>

<script>
import throttle from '@/utils/throttle'
import { addResizeListener, removeResizeListener } from 'element-ui/src/utils/resize-event'
import vv from '@/components/varVariable'

export default {
  name: 'Carousel',
  props: {
    initialIndex: {
      type: Number,
      default: 0
    },
    height: {
      type: String,
      default: ''
    },
    trigger: {
      type: String,
      default: 'hover'
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    interval: {
      type: Number,
      default: 3000
    },
    indicatorPosition: {
      type: String,
      default: ''
    },
    indicator: {
      type: Boolean,
      default: true
    },
    arrow: {
      type: String,
      default: 'hover'
    },
    type: {
      type: String,
      default: ''
    },
    loop: {
      type: Boolean,
      default: true
    },
    direction: {
      type: String,
      default: 'horizontal',
      validator(val) {
        return ['horizontal', 'vertical'].indexOf(val) !== -1
      }
    }
  },
  data() {
    return {
      items: [],
      activeIndex: -1,
      containerWidth: 0,
      timer: null,
      hover: false
    }
  },
  computed: {
    filePath() {
      return vv.fileHttp
    },
    arrowDisplay() {
      return this.arrow !== 'never' && this.direction !== 'vertical'
    },

    hasLabel() {
      return this.items.some(item => item.label.toString().length > 0)
    },

    carouselClasses() {
      const classes = ['el-carousel', 'el-carousel--' + this.direction]
      if (this.type === 'card') {
        classes.push('el-carousel--card')
      }
      return classes
    },

    indicatorsClasses() {
      const classes = ['el-carousel__indicators', 'el-carousel__indicators--' + this.direction]
      if (this.hasLabel) {
        classes.push('el-carousel__indicators--labels')
      }
      if (this.indicatorPosition === 'outside' || this.type === 'card') {
        classes.push('el-carousel__indicators--outside')
      }
      return classes
    }
  },

  watch: {
    items(val) {
      if (val.length > 0) this.setActiveItem(this.initialIndex)
    },

    activeIndex(val, oldVal) {
      this.resetItemPosition(oldVal)
      if (oldVal > -1) {
        this.$emit('change', val, oldVal)
      }
    },

    autoplay(val) {
      val ? this.startTimer() : this.pauseTimer()
    },

    loop() {
      this.setActiveItem(this.activeIndex)
    }
  },

  created() {
    this.throttledArrowClick = throttle(300, true, index => {
      this.setActiveItem(index)
    })
    this.throttledIndicatorHover = throttle(300, index => {
      this.handleIndicatorHover(index)
    })
  },

  mounted() {
    this.updateItems()
    this.$nextTick(() => {
      addResizeListener(this.$el, this.resetItemPosition)
      if (this.initialIndex < this.items.length && this.initialIndex >= 0) {
        this.activeIndex = this.initialIndex
      }
      this.startTimer()
    })
  },

  beforeDestroy() {
    if (this.$el) removeResizeListener(this.$el, this.resetItemPosition)
    this.pauseTimer()
  },

  methods: {
    handleMouseEnter() {
      this.hover = true
      this.pauseTimer()
    },

    handleMouseLeave() {
      this.hover = false
      this.startTimer()
    },

    itemInStage(item, index) {
      const length = this.items.length
      if (index === length - 1 && item.inStage && this.items[0].active ||
        (item.inStage && this.items[index + 1] && this.items[index + 1].active)) {
        return 'left'
      } else if (index === 0 && item.inStage && this.items[length - 1].active ||
        (item.inStage && this.items[index - 1] && this.items[index - 1].active)) {
        return 'right'
      }
      return false
    },

    handleButtonEnter(arrow) {
      if (this.direction === 'vertical') return
      this.items.forEach((item, index) => {
        if (arrow === this.itemInStage(item, index)) {
          item.hover = true
        }
      })
    },

    handleButtonLeave() {
      if (this.direction === 'vertical') return
      this.items.forEach(item => {
        item.hover = false
      })
    },

    updateItems() {
      this.items = this.$children.filter(child => child.$options.name === 'ElCarouselItem')
    },

    resetItemPosition(oldIndex) {
      this.items.forEach((item, index) => {
        item.translateItem(index, this.activeIndex, oldIndex)
      })
    },

    playSlides() {
      if (this.activeIndex < this.items.length - 1) {
        this.activeIndex++
      } else if (this.loop) {
        this.activeIndex = 0
      }
    },

    pauseTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },

    startTimer() {
      if (this.interval <= 0 || !this.autoplay || this.timer) return
      this.timer = setInterval(this.playSlides, this.interval)
    },

    setActiveItem(index) {
      if (typeof index === 'string') {
        const filteredItems = this.items.filter(item => item.name === index)
        if (filteredItems.length > 0) {
          index = this.items.indexOf(filteredItems[0])
        }
      }
      index = Number(index)
      if (isNaN(index) || index !== Math.floor(index)) {
        console.warn('[Element Warn][Carousel]index must be an integer.')
        return
      }
      const length = this.items.length
      const oldIndex = this.activeIndex
      if (index < 0) {
        this.activeIndex = this.loop ? length - 1 : 0
      } else if (index >= length) {
        this.activeIndex = this.loop ? 0 : length - 1
      } else {
        this.activeIndex = index
      }
      if (oldIndex === this.activeIndex) {
        this.resetItemPosition(oldIndex)
      }
    },

    prev() {
      this.setActiveItem(this.activeIndex - 1)
    },

    next() {
      this.setActiveItem(this.activeIndex + 1)
    },

    handleIndicatorClick(index) {
      this.activeIndex = index
    },

    handleIndicatorHover(index) {
      if (this.trigger === 'hover' && index !== this.activeIndex) {
        this.activeIndex = index
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-carousel__container{
  height: 95%;

  .nav_btn{
    position: relative;
    top: 50%;
    width: 80px;
    height: 80px;
    display: inline-block;
    margin-top: -40px;
    z-index: 3;

    .icon{
      display: flex;
      align-items: center;
    }
  }

  .nav_btn_left{
    left: 20px;
    transition: left .5s;

    .left_icon{
      transform:rotate(180deg);
    }
  }

  .nav_btn_left:hover{
    left: 10px;
    transition: left .5s;
  }

  .nav_btn_right{
    float: right;
    right: 20px;
    transition: right .5s;
  }

  .nav_btn_right:hover{
    right: 10px;
    transition: right .5s;
  }
}

.arrow_icon{
  opacity: .7;
}

.arrow_icon:hover{
  cursor: pointer;
}

.el-carousel__indicators{
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  li{
    .el-carousel__button{
      opacity: 1;
      width: 60px;
      height: 14px;
    }
    .el-carousel__button:hover{
      background-image: url("/nemojoyWebSiteFile/imgs/indexCarousel/indexCarouselbuttonWhite.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }

  .is-active{
    .el-carousel__button{
      background-image: url("/nemojoyWebSiteFile/imgs/indexCarousel/indexCarouselbuttonWhite.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
